<template>
  <v-container style="max-width: 1240px; padding-top: 100px; padding-bottom: 0;">
    <v-layout>
      <v-flex xs12>
        <h2>Транспортное средство</h2>
      </v-flex>
    </v-layout>

    <!-- Гос. номер -->
    <v-layout row wrap align-center>
      <v-flex xs12 sm12 md4 lg2 py-0>
        <v-text-field
          :value="documents.registrationNumber"
          label="Гос номер"
          mask="SSSSSSSSS"
          disabled
        />
      </v-flex>
      <v-flex xs12 sm12 md4 lg2 py-0>
        <v-text-field
          :value="documents.registrationNumberNew"
          label="Новый гос номер"
          :rules="[rules.russianOnly, rules.numberRule, rules.differentFromOld(documents.registrationNumber)]"
          validate-on-blur
          mask="SSSSSSSSS"
          @input="$emit('update:registrationNumberNew', $event)"
        />
      </v-flex>
      <v-flex>
        <p class="hint-text">При изменении гос номера впишите новый</p>
      </v-flex>
    </v-layout>

    <!-- Текущий документ ТС (read-only) -->
    <v-layout row wrap>
      <v-flex xs12 sm6 md3 lg3 py-0>
        <v-text-field :value="documents.seriesNumber" label="Серия и номер" disabled />
      </v-flex>
      <v-flex xs12 sm6 md3 lg3 py-0>
        <osago-date :value="documents.issueDate" label="Дата выдачи" :isDisabled="true" />
      </v-flex>
    </v-layout>

    <!-- Выбор типа нового документа -->
    <v-layout row wrap>
      <v-flex py-0 style="margin-bottom: -25px">
        <v-radio-group row :value="documents.typeNew" @change="$emit('update:typeNew', $event)">
          <v-radio label="ПТС"  value="pts"  class="pb-3" />
          <v-radio label="ЭПТС" value="epts" class="pb-3" />
          <v-radio
            label="СРТС — свидетельство о регистрации транспортного средства"
            value="srts"
            class="pb-3"
          />
        </v-radio-group>
      </v-flex>
    </v-layout>

    <!-- Новые серия/номер в зависимости от типа документа -->
    <v-layout row wrap align-center>
      <v-flex xs12 sm6 md3 lg3 py-0>
        <!-- ПТС -->
        <v-text-field
          v-if="documents.typeNew === 'pts'"
          :value="documents.seriesNumberNew"
          :rules="[rules.pts, rules.differentFromOld(documents.seriesNumber)]"
          mask="##RR ######"
          return-masked-value
          label="Новые: Серия и номер"
          validate-on-blur
          @paste="$emit('paste-doc', $event)"
          @input="$emit('update:seriesNumberNew', $event)"
        />

        <!-- СРТС -->
        <v-text-field
          v-if="documents.typeNew === 'srts'"
          :value="documents.seriesNumberNew"
          :rules="[rules.pts, rules.differentFromOld(documents.seriesNumber)]"
          :mask="vehicleDocMask"
          return-masked-value
          label="Новые: Серия и номер"
          validate-on-blur
          @paste="$emit('paste-doc', $event)"
          @input="$emit('update:seriesNumberNew', $event); $emit('update-mask')"
        />

        <!-- ЭПТС -->
        <v-text-field
          v-if="documents.typeNew === 'epts'"
          :value="documents.seriesNumberNew"
          :rules="[rules.srts, rules.differentFromOld(documents.seriesNumber)]"
          mask="###############"
          return-masked-value
          label="Новый: Номер"
          validate-on-blur
          @paste="$emit('paste-doc', $event)"
          @input="$emit('update:seriesNumberNew', $event)"
        />
      </v-flex>

      <v-flex xs12 sm6 md3 lg3 py-0>
        <osago-date
          :value="documents.issueDateNew"
          label="Новая: Дата выдачи"
          :rules="[rules.differentFromOld(documents.issueDate)]"
          :max="dateToday"
          :isRequired="false"
          @input="$emit('update:issueDateNew', $event)"
        />
      </v-flex>

      <v-flex>
        <p class="hint-text">При изменении данных впишите новые</p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { useOsagoValidationRules } from '../composables/useOsagoValidationRules'

/**
 * VehicleDocumentSection — "тупой" компонент секции ТС.
 *
 * Emits:
 *   update:registrationNumberNew(value)
 *   update:typeNew(value)
 *   update:seriesNumberNew(value)
 *   update:issueDateNew(value)
 *   update-mask
 *   paste-doc(event)
 */
export default {
  name: 'VehicleDocumentSection',

  props: {
    documents: {
      type: Object,
      required: true,
    },
    vehicleDocMask: {
      type: String,
      default: 'S',
    },
    dateToday: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      rules: {
        russianOnly: (v) => {
          if (!v) return true
          return !(/[^А-Я0-9]/.test(v)) || 'Допускаются только русские буквы'
        },
        numberRule: (v) => {
          if (!v) return true
          return (
            /^[АВЕКМНОРСТУХ][\d]{3}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) ||
            'Неверный формат'
          )
        },
        pts: (v) => {
          if (!v) return true
          return (
            /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) ||
            /^[A-Za-zА-Яа-яЁё]{2} \d{6}$/.test(v) ||
            'Неверный формат'
          )
        },
        srts: (v) => {
          if (!v) return true
          return /^\d{15}$/.test(v) || 'Неверный формат'
        },
        differentFromOld: (oldValue) => (v) => {
          if (!v) return true
          if (v === oldValue) return 'Новое значение не должно совпадать со старым'
          return true
        },
      }
    }
  }
}
</script>

<style scoped>
.hint-text {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/change/components/VehicleDocumentSection.vue